<template>
  <ul class="list-unstyled mb-0" v-if="props.citizenships?.length">
    <li v-for="citizenship of props.citizenships">
      <span>{{ t("COUNTRY_CODES." + citizenship) }}</span>
    </li>
  </ul>

  <span v-else>{{ t("UNKNOWN") }}</span>
</template>

<script setup lang="ts">
import {useI18n} from "vue-i18n";

const {t} = useI18n();

const props = defineProps<{
  citizenships?: string[];
}>();
</script>
